import getConfiguration from '../configuration';
var App = /** @class */ (function () {
    function App(communicator, definition, alsProvider) {
        var _this = this;
        this.communicator = communicator;
        this.definition = definition;
        this.alsProvider = alsProvider;
        this.plugins = new Map();
        this.configuration = getConfiguration(this.communicator);
        this.plugin = function (plugin) {
            _this.plugins.set(plugin.key, plugin);
            return _this;
        };
        this.use = function (plugin) {
            var result = _this.plugins.get(plugin.key);
            if (!result) {
                // Typically trying to access a plugin which is not defined will be a fatal error
                // In the limited case where a valid fallback exists, the user can handle this exception.
                throw "Plugin with key " + plugin.key + " (from " + plugin + ") has not been attached to the app!";
            }
            return result.use(_this);
        };
    }
    return App;
}());
export default App;
//# sourceMappingURL=app.js.map